import { Card, CardContent, CardHeader } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getParks, loadPark } from '../../redux/componentsPark/componentsParkActions';
import TableWithPagination from '../Table/TableWithPagination';
import withAuth from '../withAuth';

class ParksTab extends Component {

    constructor(props) {
        super(props);

        this.state = {
            columns: [
                {
                    columns: [
                        {
                            Header: "Libellé",
                            accessor: "name",
                        },
                        {
                            Header: "Description",
                            accessor: "description",
                        },
                    ]
                },
            ]
        }

        this.props.getParks(this.props.sites.selectedSite, this.props.sites.sites, this.props.activeUser);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.getParks(this.props.sites.selectedSite, this.props.sites.sites, this.props.activeUser);
    }

    loadPark(park) {
        this.props.loadPark(park);
        this.props.history.push("/parks/park");
    }

    getTableTrProps(state, rowInfo) {
        if (rowInfo && rowInfo.row) {
            return {
                onClick: this.loadPark.bind(this, rowInfo.row._original),
                style: {
                    cursor: 'pointer'
                },
            }
        } else {
            return {}
        }
    }

    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin without-side-padding">
                <Card className="card">
                    <CardHeader title={"Parcs"} titleTypographyProps={{ variant: "h6", color: 'primary' }}></CardHeader>
                    <CardContent className="without-side-padding-only-small-screen">
                        <TableWithPagination
                            data={this.props.parks}
                            columns={this.state.columns}
                            getTrProps={this.getTableTrProps.bind(this)} />
                    </CardContent>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        parks: state.componentsPark.parks,
        activeUser: state.activeUser,
        sites: state.sites,
        inputSearch: state.componentsPark.inputSearch,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getParks: (customerSiteId, allSites, user) => dispatch(getParks(customerSiteId, allSites, user)),
        loadPark: (park) => dispatch(loadPark(park)),
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(ParksTab);
